import styled from 'styled-components';

const StyledModalWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 5;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.85);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 5;
	width: 460px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 30px;
`;

const StyledModalHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledButtonsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
	margin-top: 20px;
`;

export {
	StyledButtonsGrid,
	StyledContainer,
	StyledModalHead,
	StyledModalWrapper,
};
